export { InitialAuthorSection } from '@/components/base/Post/TwitterPost/InitialAuthorSection';
export { PollOptions } from '@/components/base/Post/TwitterPost/PollOptions';
export { PostTypeBadge } from '@/components/base/Post/TwitterPost/PostTypeBadge';
export { TwitterPostFooter } from '@/components/base/Post/TwitterPost/TwitterPostFooter';

// Default export for backwards compatibility
export { default } from '@/components/base/Post/TwitterPost/TwitterPost';
